






















import Card from "@/components/utility/Card.vue";
import { SignDigitalSignatureRequestViewModelGen } from "@/services/sign/v1/data-contracts";
import { SignRequestModule } from "@/store/modules/sign-request.store";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import ReportDocumentSignRequestStepperMixin from "./ReportDocumentSignRequestStepperMixin.vue";
import { IStepper, SignRequestStepperPageEnum } from "./ReportDocumentSignRequestSteps.vue";
import { DigitalSignatureRequestStatusEnum } from "./SignRequestTable.vue";

@Component({
  components: {
    Card
  }
})
export default class ReportDocumentSignRequestStepperMailSuccess extends mixins(ReportDocumentSignRequestStepperMixin)
  implements IStepper {
  @Prop()
  signRequest!: SignDigitalSignatureRequestViewModelGen;

  previous() {
    this.currentStep = SignRequestStepperPageEnum.SUCCESS;
  }

  mounted() {
    // update state silently in background
    SignRequestModule.updateState({
      partnerId: this.signRequest.partnerId,
      signRequestId: this.signRequest.id,
      data: {
        status: DigitalSignatureRequestStatusEnum.SENT
      }
    }).catch(e => this.$log.error(e));
  }

  next() {
    this.$emit("close");
  }
}
